module.exports = __webpack_public_path__ + "img/Shva_action.c342d2ef.png";